import * as React from "react";
import { FieldProps } from "formik";
import { Form, Select } from "antd";

const FormItem = Form.Item;

export const SelectField: React.FC<
  FieldProps<any> & {
    prefix?: React.ReactNode;
    label?: string;
    className?: string;
    showSearch?: boolean;
    placeholder?: string;
    filterOption?: (input: string, option?: any) => boolean;
    options?: { key: string; value: string; label: string }[];
    children?: React.ReactNode;
    onValueChange?: (newValue: any) => void;
  }
> = ({
  field: { onChange, ...field },
  form: { touched, errors, submitCount, setFieldValue, setFieldTouched },
  label,
  className = "bg-[#171820] [&_.ant-select-selection-placeholder]:!text-white [&_.ant-select-selection-placeholder]:!opacity-80 [&_.ant-select-selector]:!text-white",
  showSearch,
  placeholder,
  filterOption,
  options,
  onValueChange,
  ...props
}) => {
  const shouldShowError = Boolean(touched[field.name] || submitCount > 0);
  const rawError = shouldShowError ? errors[field.name] : undefined;
  const errorMsg =
    typeof rawError === "string"
      ? rawError
      : Array.isArray(rawError)
      ? rawError.join(", ")
      : undefined;

  return (
    <FormItem
      label={label}
      help={errorMsg}
      validateStatus={errorMsg ? "error" : undefined}
    >
      <Select
        {...field}
        {...props}
        value={field.value || undefined}
        showSearch={showSearch}
        className={className}
        placeholder={placeholder}
        filterOption={filterOption}
        {...(options && { options })}
        virtual={false}
        onChange={(newValue: any) => {
          setFieldValue(field.name, newValue);
          onValueChange?.(newValue);
        }}
        onBlur={() => setFieldTouched(field.name, true)}
      >
        {!options && props.children}
      </Select>
    </FormItem>
  );
};
